import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 7,
	height: 14,
	viewBox: "0 0 7 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.20806 6.89752L6.67773 1.42785L5.61707 0.367187L0.677733 5.30653C-0.200946 6.18521 -0.200947 7.60983 0.677733 8.48851L5.61707 13.4278L6.67773 12.3672L1.20806 6.89752Z",
		fill: "currentColor"
	})
});
export default SvgChevronLeft;
